// The machine's system ID, read from the BOR System Registration App running on it, and the copy the API
// helper sends with every request (examSoftwareSystemId header, see axios.js).
const KEY = "BOR_SYSTEM_ID";
// Sent on window whenever the stored ID changes (the header shows it)
export const SYSTEM_ID_CHANGED = "bor-system-id-changed";

export const getStoredSystemId = () => localStorage.getItem(KEY);

export const storeSystemId = (id) => {
    if (id) localStorage.setItem(KEY, id);
    else localStorage.removeItem(KEY);
    window.dispatchEvent(new Event(SYSTEM_ID_CHANGED));
};

// The machine a login is tied to: the exam backend puts it in the token (`sys`) at login, and the exam is
// locked to that machine
export const tokenSystemId = (token) => {
    try {
        const payload = JSON.parse(atob(String(token).split(".")[1].replace(/-/g, "+").replace(/_/g, "/")));
        return payload.sys || null;
    } catch (err) {
        return null;
    }
};

export const readSystemId = async (timeoutMs = 4000) => {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), timeoutMs);
    try {
        const response = await fetch(`${process.env.REACT_APP_MAC_URL}`, { signal: controller.signal });
        const data = await response.json();
        return data?.data?.mac_id || null;
    } catch (err) {
        return null;
    } finally {
        clearTimeout(timer);
    }
};

/**
 * Reads the ID again and stores it, so the server judges every request by the machine it really comes from
 * (the exam is locked to one machine). A registration app that does not answer leaves no ID: the ID is always
 * live, never one read earlier.
 */
export const refreshSystemId = async () => {
    const id = await readSystemId();
    storeSystemId(id);
    return id;
};
